import { render, staticRenderFns } from "./VerificacionCliente.vue?vue&type=template&id=5d778978&"
import script from "./VerificacionCliente.vue?vue&type=script&lang=js&"
export * from "./VerificacionCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\simulador_new\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d778978')) {
      api.createRecord('5d778978', component.options)
    } else {
      api.reload('5d778978', component.options)
    }
    module.hot.accept("./VerificacionCliente.vue?vue&type=template&id=5d778978&", function () {
      api.rerender('5d778978', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Formularios/VerificacionCliente/VerificacionCliente.vue"
export default component.exports